let _ = require('lodash');
var moment = require('moment');

exports.guessBoost = function(user) {
    switch(user.technologySection) {
        case 1: return 100;
        case 2: return 156;
        case 3: return 279;
        case 4: return 326;
        case 5: return 472;
        case 6: return 557;
        case 7: return 583;
        case 8: return 653;
        case 9:
        case 10:
        case 11:
        case 12:
        case 13:
        case 14:
        case 15: return 700;
        default: return 100;
    }
};

exports.transformBoostName = function(boost) {
    if( boost ) {
        boost = boost.toLowerCase();
        return (boost === "dust" ? "magic_dust" : boost);
    }
};

exports.mapDomainAndServerName = function(serverLetter) {
    if( !serverLetter ) {
        return "INVALID";
    }
    let matches = serverLetter.match(/(..)(\d)/i);
    let domain = matches[1];
    let number = matches[2];

    if( domain === 'zz') {
        return "ZZ1 - BETA1";
    }
    let worldName = "Unnamed";

    switch(number) {
        case '1': worldName = "Arendyll"; break;
        case '2': worldName = "Winyandor";break;
        case '3': worldName = "Felyndral"; break;
        case '4': worldName = "Khelonaar"; break;
        case '5': worldName = "Elcysandir"; break;
        case '6': worldName = "Sinya Arda"; break;
        case '7': worldName = "Ceravyn"; break;
        case '8': worldName = "Harandar"; break;
    }

    return domain.toUpperCase() + number + " - " + worldName;
};


exports.getFellowshipLink = function(server, id) {
    if( _.isString(server) && !_.isObject(id) ) {
        return `http://elvenstats.com/fellowship/${server}/${id}`;
    }
};

exports.getPlayerLink = function(server, id) {
    if( _.isString(server) && !_.isObject(id) ) {
        return `http://elvenstats.com/player/${server}/${id}`;
    }
};

exports.computeOtherFellowshipMetrics = function(users, fellowship) {
    let inactiveMembers = _.filter(users, {isActive: false} );
    let usersWithCityMap = _.size( _.filter(users, function(u) { return u.cityReport } ));
    let last4 = exports.getLastNTournaments(fellowship.tournaments, 4);
    let usersAscending = _.orderBy(users, "currScore", "asc");

    console.log("LAST4: ", last4);
    // TODO REMOVE ONCE TOURNAMENTS ARE STABLE
    const chestAverage = _.size(last4) > 0 ?_.sumBy(last4, "chests") / _.size(last4) : 0;
    const tournamentAverage = _.size(last4) > 0 ? _.sumBy(last4, "points") / _.size(last4) : 0;

    let stats = {
      // chestAverage: _.sumBy(last4, "chests") / 4,
      // tournamentAverage: _.sumBy(last4, "points") / 4,
        chestAverage: chestAverage,
        tournamentAverage: tournamentAverage,
        averageTechnologySection: (_.sumBy(users, function(u){ return u.technologySection || 0; }) / usersWithCityMap) || 0,
        medianScore: _.size(users) === 0 ? 0 : usersAscending[Math.floor(_.size(users) / 2)].currScore,
        averageScore: _.size(users) === 0 ? 0 : _.sumBy(users, "currScore") / _.size(users),
        minimumScore: _.size(users) === 0 ? 0 : _.first( usersAscending ),
        maximumScore: _.size(users) === 0 ? 0 : _.last( usersAscending ),
        activeMembers: _.size(users) - _.size(inactiveMembers),
        inactiveMembers: _.size(inactiveMembers),
        statsUpdatedAt: new Date(),
        membersWithoutCityMap: _.size( _.filter( users, function(u) { return !u.cityReport }) ),
    };

   return stats;
}

exports.computeGoodsBreakdownForFellowship = function(users) {
    // users = _.cloneDeep(users);
    //console.log( JSON.stringify(users) );
    _.each(users, function (user) {
        user = exports.calculateProductionForUser(user);
    });
    // Sum The entire Fellowship
    let sum = sumByArray(users);
    let summary = {};
    try {
        summary = summarizeFsGoods(sum.cityReport, users);
    }catch(err) {
        console.error("Unable to summarizeFSGoods for fellowship: " + _.get(users, "[0].fellowship") + " member count: " + _.size(users) );
    }

    return summary;
}

exports.initializeUsersGoods = function(users) {
    _.each(users, function (u) {
        exports.initializeGoodsForUser(u);
    });
};

exports.initializeGoodsForUser = function(u) {
    u.boost1 = exports.transformBoostName(u.boost1);
    u.boost2 = exports.transformBoostName(u.boost2);
    u.boost3 = exports.transformBoostName(u.boost3);
    u.boost1Percent = u.boost1Percent || exports.guessBoost(u);
    u.boost2Percent = u.boost2Percent || exports.guessBoost(u);
    u.boost3Percent = u.boost3Percent || exports.guessBoost(u);
    u.collectsPerDay = u.collectsPerDay || 3;
    if (!u.cityReport) {
        u.cityReport = {
            production: {}
        };
    }
    if (u.cityReport) {
        try {
            _.extend(u.cityReport.production, {
                marbleComputed: 0,
                steelComputed: 0,
                planksComputed: 0,
                crystalComputed: 0,
                scrollsComputed: 0,
                silkComputed: 0,
                elixirComputed: 0,
                magic_dustComputed: 0,
                gemsComputed: 0,
            });
            u.cityReport.cultureBoostPercent = exports.computeCultureBoostPercentForUser(u) * 100;
        }
        catch (err) {
            console.error(err);
        }
    }
};

function summarizeFsGoods(report, users) {
    let production = _.get(report, "production");
    let result = {};

    var totalT1 = production.marbleComputed + production.steelComputed + production.planksComputed;
    var totalT2 = production.crystalComputed + production.scrollsComputed + production.silkComputed;
    var totalT3 = production.elixirComputed + production.magic_dustComputed + production.gemsComputed;

    var boosts = {
        1: ['marble', 'steel', 'planks'],
        2: ['crystal', 'scrolls', 'silk'],
        3: ['elixir', 'magic_dust', 'gems']
    };

    result.tier1 = totalT1;
    result.tier2 = totalT2;
    result.tier3 = totalT3;
    result["1"] = [];
    result["2"] = [];
    result["3"] = [];

    _.each(["1", "2", "3"], function (tier) {
        var total = totalT1;
        if (tier === "2") { total = totalT2;}
        else if (tier === "3") { total = totalT3; }

        _.each(boosts[tier], function (boost) {
            var boostMembers = _.filter(users, function (user) {
                return user.boost1 === boost || user.boost2 === boost || user.boost3 === boost;
            });
            result[tier].push({
                name: boost,
                total: production[boost + "Computed"],
                percent: ((production[boost + "Computed"] / total) * 100).toFixed(0),
                memberCount: _.size(boostMembers),
                members: _.map(_.sortBy(boostMembers, "cityReport.production['" + boost + "Computed']").reverse(),
                    function (member) {
                        return [member.username.substring(0, 10),
                                _.get(member, "cityReport.production['" + boost + "Computed']")];
                    })
            });
        });
    });

    try {
        result.boostsNeeded = [];
        _.each(["1", "2", "3"], function (tier) {
            let boost = _.minBy(result[tier], function (b) {
                return parseInt(b.percent);
            });
            if (boost && parseInt(boost.percent) < 29) {
                result.boostsNeeded.push(boost.name);
            }
        });
    }
    catch (err) {
        console.error(err);
    }

    result.cityReport = report;


    return result;
}

function sumByArray(arr) {
    var first = _.first(arr);
    var keys = _.keys(first);
    var result = {};
    _.each(keys, function (key) {
        if (key === "_id") {

        }
        else if (_.isNumber(first[key])) {
            result[key] = _.sumBy(arr, key);
        }
        else if (_.isObject(first[key])) {
            var subArray = _.map(arr, key);
            result[key] = sumByArray(subArray);
        }
        else {
            result[key] = first[key];
        }
    });

    return result;
}

exports.calculateProductionForUser = function(user) {
    var pairs = [{boost: user.boost1, percent: user.boost1Percent}, {boost: user.boost2, percent: user.boost2Percent},
        {boost: user.boost3, percent: user.boost3Percent}];
    _.each(pairs, function (pair) {
        let boost = pair.boost;
        let percentage = (pair.percent / 100);
        if (boost) {
            try {
                let productionPath = `cityReport.production['${boost}']`;
                let productionPath2 = `cityReport.production['${boost}2']`;   // <-- This is for LVL24 + goods.
                let productionPathComputed = `cityReport.production['${boost}Computed']`;
                let baseProduction = (((_.get(user, productionPath) || 0) - (_.get(user, productionPath2) || 0)) *
                                      exports.getFrequencyMultiplierForUser(user, false)) +
                                     ((_.get(user, productionPath2) || 0) * exports.getFrequencyMultiplierForUser(user, true));
                let boostPercent = (percentage + 1.0) + ((user.mountainHallBoostPercent || 1) - 1);

                let boostedProduction = baseProduction * (boostPercent);

                //console.log(`${user.username}, boost: ${boost}, base: ${baseProduction}, percent: ${boostPercent}, total: ${boostedProduction}`);

                _.set(user, productionPathComputed, boostedProduction);
            }
            catch (err) {
                console.log("error calculating goods: ", err);
            }
        }
    });

    return user;
};


exports.getFrequencyMultiplierForUser = function(user, isGreaterThanLevel23) {
    let collects = user.collectsPerDay;
    return exports.getFrequencyMultipler(collects, isGreaterThanLevel23);
};

exports.getFrequencyMultipler = function(collectsPerDay, isGreaterThanLevel23) {
    if (!collectsPerDay || collectsPerDay < 1) { collectsPerDay = 1;}
    if (collectsPerDay > 6) { collectsPerDay = 6; }

    if (isGreaterThanLevel23) {
        const multipliers = [1, 2, 2.09375, 2.6406, 3.1875, 3.734375];
        return multipliers[collectsPerDay - 1];
    }
    else {
        const multipliers = [1, 1.167032967, 1.485714286, 1.5396, 1.8582, 2.176923077];
        return multipliers[collectsPerDay - 1];
    }
};

exports.computeCultureBoostPercentForUser = function(user) {
    let workingPopulation = _.get(user, "cityReport.workingPopulation");
    let requiredCulture = _.get(user, "cityReport.requiredCulture");
    let availableCulture = _.get(user, "cityReport.availableCulture");
    return exports.computeCultureBoostDiscrete( workingPopulation, requiredCulture, availableCulture ) ;
};

// Some polyfill issue with Math.log10
function log10(x) {
    return Math.log(x) * Math.LOG10E;
}

exports.computeCultureBoostDiscrete = function( workingPopulation, requiredCulture, availableCulture ) {

    try {
        let percents = [{ mult: 0.2, percent: 1.25 }, { mult: 0.4, percent: 1.5 }, { mult: 0.6, percent: 1.6 },
            { mult: 0.8, percent: 1.7 }].reverse();

        for (let i = 0; i < percents.length; i++) {
            const temp = (workingPopulation + requiredCulture) * percents[i].mult;
            const digits = Math.floor(log10(temp)) - 1;
            const additionalNeeded = Math.round(temp / Math.pow(10, digits)) * Math.pow(10, digits);

            if (availableCulture >= additionalNeeded) {
                return percents[i].percent;
            }
        }
    }catch(err) {
        console.error("Unable to calculate culture boost: ", err);
    }

    return 1.0;
};

exports.getNumberOfChests = function(score) {
    if(score < 600){
        return 0;
    }
    else if( score < 1800){
        return 1;
    }
    else if (score < 3700) {
        return 2;
    }
    else if (score < 6300) {
        return 3;
    }
    else if (score < 9700) {
        return 4;
    }
    else if (score < 13900) {
        return 5;
    }
    else if (score < 19000) {
        return 6;
    }
    else if (score < 25000) {
        return 7;
    }
    else if (score < 32000) {
        return 8;
    }
    else if (score < 40000) {
        return 9;
    }
    else{
        return 10;
    }
};

exports.getLastNTournaments = function(obj, n) {
    let tournaments = obj.tournaments || obj;
    return _.filter( _.takeRight( _.sortBy( tournaments, "date"), n), function(tournament) {
        return moment.utc().diff(tournament.date, "days") < ((7*n)+1);
    });
};

exports.getLast4TournamentsSum = function(user) {
    return _.sumBy( exports.getLastNTournaments(user,4), "points");
};

exports.getLast4TournamentsAvg = function(user) {

  let tournaments = exports.getLastNTournaments(user,4);
  let sum = _.sumBy( tournaments, "points");

  //console.log("sum / size TOURNAMNETS: " + sum + " " + _.size(tournaments) );
  return sum / _.size(tournaments);
  //  return exports.getLast4TournamentsSum(user)/4;
};

/**
 *
 * @param fellowship
 * @param user
 * @returns {{total: number, reason: string, scores: Array}}
 */
exports.calculateMatchMakerCompatibilityScore = function(fellowship, user, isUserMode) {

    // ASSUMPTIONS COMING IN... fellowship will have EITHER an open slot or at least one inactive member.

    const POINTS_PER_MATCHING_BOOST = 125;

    const POINTS_FOR_OPEN_SLOT=100;     // A fellowship with an open slot is more likely to accept than one which has to replace an inactive (hoping the member might come back)
    const POINTS_FOR_INACTIVE_SLOT=50;

    const PENALTY_FOR_UNDER_TEN_MEMBERS =  -300;
    const PENALTY_FOR_UNDER_FIFTEEN_MEMBERS =  -200;
    const PENALTY_FOR_UNDER_TWENTY_MEMBERS =  -150;

    const BONUS_FOR_ABOVE_MEDIAN = 75;
    const BONUS_FOR_SCORE_IN_RANGE = 200;
    const PENALTY_FOR_BELOW_MEDIAN_BUT_ABOVE_MINIMUM_SCORE = -50;
    const PENALTY_FOR_BELOW_MINIMUM_SCORE = -250; // If the player would be in dead last, they're less likely to be accepted by the FS so reduce

    const BONUS_FOR_ABOVE_AVERAGE_CHAPTER = -75;
    const BONUS_FOR_CHAPTER_IN_RANGE = 250;
    const PENALTY_FOR_UNDER_AVERAGE = -75;

    const PENALTY_FOR_ABOVE_TOURNEY_PARTIPATION = -150;
    const BONUS_FOR_TOURNEY_PARTICIPATION_IN_RANGE = 250;
    const PENALTY_FOR_BELOW_TOURNEY_PARTIPATION = -75;

    // isUserMode
    const BONUS_FOR_NO_FELLOWSHIP = 250;


    let score = [];

    let matchingBoosts = (_.includes(fellowship.boostsNeeded, user.boost1) ? 1 : 0) +
                         (_.includes(fellowship.boostsNeeded, user.boost2) ? 1 : 0) +
                         (_.includes(fellowship.boostsNeeded, user.boost3) ? 1 : 0);

    score.push( {text: matchingBoosts + " Matching Boosts", value: matchingBoosts * POINTS_PER_MATCHING_BOOST});



    // FELLOWSHIP BASED ON USER RANGE
    if( isNumberInRange( fellowship.medianScore, fellowship.medianScore * 0.15, user.currScore )) { score.push({text: "Score Ranges Are Similar!", value: BONUS_FOR_SCORE_IN_RANGE}) }
    else if( user.currScore < fellowship.minimumScore ) { score.push({text: "You're score is < lowest member", value: PENALTY_FOR_BELOW_MINIMUM_SCORE}) }
    else if( user.currScore > fellowship.medianScore ) { score.push({text: "You're score is > median score", value: BONUS_FOR_ABOVE_MEDIAN })}
    else { score.push({text: "Your score is below median", value: PENALTY_FOR_BELOW_MEDIAN_BUT_ABOVE_MINIMUM_SCORE })}

    if( isNumberInRange( fellowship.averageTechnologySection, 2, user.technologySection) ) { score.push({text: "Similar Tech Tree", value: BONUS_FOR_CHAPTER_IN_RANGE}); }
    else if( user.technologySection < fellowship.averageTechnologySection ) { score.push({text:"You're further in Tech Tree", value: BONUS_FOR_ABOVE_AVERAGE_CHAPTER }); }
    else { score.push({text: "Your behind in Tech Tree", value: PENALTY_FOR_UNDER_AVERAGE }); }

    // TOURNAMENT PLAY STYLE, I calculate what a player "deserves" in terms of chest (if the fellowship was completely fair)
    let userChestAverage = user.chestAverage;
    if( isNumberInRange( fellowship.chestAverage, 0.75, userChestAverage) ) { score.push({text: "Tourney Participation Similar", value: BONUS_FOR_TOURNEY_PARTICIPATION_IN_RANGE}); }
    else if( userChestAverage > fellowship.chestAverage ) { score.push({text:"You're More Active in Tournaments", value: PENALTY_FOR_ABOVE_TOURNEY_PARTIPATION }); }
    else { score.push({text: "You are less active in tournaments.", value: PENALTY_FOR_BELOW_TOURNEY_PARTIPATION }); }




    if( isUserMode ) {
        if( !user.fellowship ) {
            score.push({text:"User is not in a fellowship", value: BONUS_FOR_NO_FELLOWSHIP });
        }
    } else {
        if( fellowship.memberCount < 25 ) { score.push({text: "Fellowship has an open slot", value: POINTS_FOR_OPEN_SLOT}) }
        else if( fellowship.activeMembers < 25 ) { score.push({text: "Fellowship has an inactive member", value: POINTS_FOR_INACTIVE_SLOT}) }

        // GIVE PENALTY TO FELLOWSHIPS WITH LOW MEMBERS - Not too big of one though --> Logic: The user would prefer to be part of a big team and low memberships are often indicative of leadership problem.
        if( fellowship.memberCount < 10 ) { score.push({text: "Fellowship has < 10 Members", value: PENALTY_FOR_UNDER_TEN_MEMBERS}) }
        else if( fellowship.memberCount < 15 ) { score.push({text: "Fellowship has < 15 Members", value: PENALTY_FOR_UNDER_FIFTEEN_MEMBERS}) }
        else if( fellowship.memberCount < 20 ) { score.push({text: "Fellowship has < 20 Members", value: PENALTY_FOR_UNDER_TWENTY_MEMBERS}) }
    }

    // if( isNumberInRange( fellowship.tournamentAverage/25, (fellowship.tournamentAverage/25) * 0.15, userTournamentAverage) ) { score.push({text: "Tourney Participation Similar", value: BONUS_FOR_TOURNEY_PARTICIPATION_IN_RANGE}); }
    // else if( userTournamentAverage > fellowship.tournamentAverage/25 ) { score.push({text:"You are More Active in Tournaments than this FS", value: PENALTY_FOR_ABOVE_TOURNEY_PARTIPATION }); }
    // else { score.push({text: "You are less active in tournaments.", value: PENALTY_FOR_BELOW_TOURNEY_PARTIPATION }); }


    // TOURNAMENT: Add bonus points if the member is active in tournaments...
    // Idea is a fellowship will often be willing to take a lower scoring player if they're active in tournaments.
    // THIS BONUS SHOULD ONLY BE APPLIED WHEN FELLOWSHIPS ARE LOOKING FOR PLAYERS NOT THE REVERSE

    // These will come into play when doing the User search.
    // const BONUS_FOR_TOURNAMENT_AVERAGE_ABOVE_2000 = 250;
    // const BONUS_FOR_TOURNAMENT_AVERAGE_ABOVE_1500 = 200;
    // const BONUS_FOR_TOURNAMENT_AVERAGE_ABOVE_1000 = 150;
    // const BONUS_FOR_TOURNAMENT_AVERAGE_ABOVE_500 = 50;
    // const BONUS_FOR_TOURNAMENT_AVERAGE_ABOVE_250 = 25;

    // if( userTournamentAverage >= 2000 ) { score.push({text: "BONUS_FOR_TOURNAMENT_AVERAGE_ABOVE_2000", value: BONUS_FOR_TOURNAMENT_AVERAGE_ABOVE_2000}) }
    // else if( userTournamentAverage >= 1500 ) { score.push({text: "BONUS_FOR_TOURNAMENT_AVERAGE_ABOVE_1500", value: BONUS_FOR_TOURNAMENT_AVERAGE_ABOVE_1500}) }
    // else if( userTournamentAverage >= 1000 ) { score.push({text: "BONUS_FOR_TOURNAMENT_AVERAGE_ABOVE_1000", value: BONUS_FOR_TOURNAMENT_AVERAGE_ABOVE_1000}) }
    // else if( userTournamentAverage >= 500 ) { score.push({text: "BONUS_FOR_TOURNAMENT_AVERAGE_ABOVE_500", value: BONUS_FOR_TOURNAMENT_AVERAGE_ABOVE_500}) }
    // else if( userTournamentAverage >= 250 ) { score.push({text: "BONUS_FOR_TOURNAMENT_AVERAGE_ABOVE_250", value: BONUS_FOR_TOURNAMENT_AVERAGE_ABOVE_250}) }

    let reason = "";
    _.each(score, (score) => {
        reason += (score.value > 0 ? "+" : "") + score.value + ": " + score.text + "\n";
    });


    return {
        total: _.sumBy(score, "value"),
        reason: reason,
        scores: score,
    };
};

function isNumberInRange( centerPoint, variance, valueToTest ) {
    return valueToTest > (centerPoint - variance) &&
           valueToTest < (centerPoint + variance);
}

 //module.exports = exports;



// WEBPACK FOOTER //
// ./src/lib/elven-stats.js